import { put, post, get } from "src/services/api";

const fetchCollections = async (params) => {
  const endpoint = `v2/assistants/collections/${params.selectedAssistantId}/${params.collectionName}/all`;
  return await get({ endpoint });
};

const fetchCollection = async (params) => {
  const endpoint = `v2/assistants/collections/${params.selectedAssistantId}/${params.collectionName}/${params.collectionKey}/${params.collectionInstanceKey}`;
  return await get({ endpoint });
};

const updateCollection = async (params) => {
  const endpoint = `v2/assistants/collections/${params.selectedAssistantId}/${params.collectionName}/${params.collectionKey}/${params.collectionInstanceKey}`;
  return await put({ endpoint, data: params.payload, headers: { pageName: params.pageName } });
};

const fetchCollectionRefs = async (params) => {
  const endpoint = `v2/assistants/${params.selectedAssistantId}/collection-refs/${params.collectionId}`;
  return await get({ endpoint, params: params.params });
};

const revealSecret = async (params) => {
  const endpoint = `v2/assistants/collections/${params.selectedAssistant.assistantId}/${params.collectionName}/${params.collectionKey}/${params.collectionInstanceKey}/${params.integrationEnv}/secrets/${params.secretId}`;
  return await get({ endpoint, headers: { pageName: params.pageName }, params: { mode: params.systemMode } });
};

const duplicateCollection = async (params) => {
  const endpoint = `v2/assistants/collections/${params.selectedAssistantId}/${params.collectionName}/${params.skillTypeKey}/${params.skillInstanceKey}/duplicate`;
  return await post({ endpoint, data: params.body });
};

const testExpression = async (params) => {
  const endpoint = `v2/assistants/collections/${params.selectedAssistantId}/${params.collectionName}/${params.collectionKey}/test-expression/${params.mode}`;
  return await post({ endpoint, data: { expression: params.expression, testInput: params.testInput } });
};

export default {
  fetchCollections,
  fetchCollection,
  updateCollection,
  fetchCollectionRefs,
  revealSecret,
  duplicateCollection,
  testExpression
};
